export const firebaseConfig = {
  apiKey: "AIzaSyBhudCexuOPwEQuGSFkOhi2x7QUE1t7Z7I",
  authDomain: "shift-app-24b30.firebaseapp.com",
  projectId: "shift-app-24b30",
  storageBucket: "shift-app-24b30.appspot.com",
  messagingSenderId: "68662344045",
  appId: "1:68662344045:web:cf68f4072452dbefd38264",
  measurementId: "G-BNYWYMK5QJ",
};
